export default "__VITE_ASSET__C0slC$Cq__"